// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { TxnTemplateType } from './TxnTemplateType';
import { TxnTemplateQbType } from './TxnTemplateQbType';
import { QbCustomerDto } from './QbCustomerDto';
import { TxnTemplateInterval } from './TxnTemplateInterval';
import { AuthorizeNetPaymentProfileDto } from './AuthorizeNetPaymentProfileDto';
import { QbClassDto } from './QbClassDto';
import { QbTermsDto } from './QbTermsDto';
import { QbSalesRepDto } from './QbSalesRepDto';
import { QbTemplateDto } from './QbTemplateDto';
import { QbCustomerMsgDto } from './QbCustomerMsgDto';
import { TxnTemplateLineDto } from './TxnTemplateLineDto';
import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.TxnTemplateDto
export class TxnTemplateDto extends EntityBaseDto {
    public active: boolean = false;
    public type: TxnTemplateType = null;
    public qbType: TxnTemplateQbType = null;
    public customer: QbCustomerDto = null;
    public interval: TxnTemplateInterval = null;
    public note: string = null;
    public autoDebitProfile: AuthorizeNetPaymentProfileDto = null;
    public class: QbClassDto = null;
    public terms: QbTermsDto = null;
    public salesRep: QbSalesRepDto = null;
    public template: QbTemplateDto = null;
    public customerMsg: QbCustomerMsgDto = null;
    public poNumber: string = null;
    public memo: string = null;
    public qbToBeEmailed: boolean = false;
    public review: boolean = false;
    public lines: TxnTemplateLineDto[] = [];
}


    



